import _ from "lodash";

export function ADD_ENTITIES(nextState, { entities }, state) {
  if (!entities) {
    return;
  }
  Object.keys(entities).forEach((entityType) => {
    const existingEntitiesOfType = entities[entityType];
    nextState[entityType] = nextState[entityType] || {};
    Object.keys(existingEntitiesOfType).forEach((guid) => {
      const entity = existingEntitiesOfType[guid];
      const existingEntity = state[entityType] && state[entityType][guid];
      if (!existingEntity) {
        nextState[entityType][entity.guid] = entity;
        return;
      }
      const updates = ["metadata", "spec", "status"].reduce(
        (accumulator, key) => {
          if (entity[key] === undefined) {
            return accumulator;
          }
          accumulator[key] = {
            ...nextState[entityType][entity.guid][key],
            ...entity[key],
          };
          return accumulator;
        },
        {}
      );

      const updatedEntity = {
        ...existingEntity,
        ...entity,
        ...updates,
      };

      if (_.isEqual(updatedEntity, existingEntity)) {
        return;
      }
      nextState[entityType][entity.guid] = updatedEntity;
    });
  });
}

export function UPDATE_ENTITY(nextState, { entityType, id, updates }, state) {
  const existingEntity = state[entityType][id];
  nextState[entityType][id] = {
    ...existingEntity,
    ...updates,
  };
}
